export default __webpack_public_path__ + "static/media/icon-patient.483028a5.svg";